(function () {
  function markLoaded(el, img) {
    if (!el) return;
    el.classList.add('is-loaded');
    el.classList.remove('m-image-skeleton');
    if (img) img.setAttribute('data-skeleton-done', '');

    var ri = el.tagName === 'RESPONSIVE-IMAGE' ? el : el.querySelector && el.querySelector('responsive-image');
    if (ri) ri.classList.add('m-image-loaded');
  }

  function bindImg(el, img) {
    if (!img) return;

    if (img.complete && img.naturalWidth > 0) {
      markLoaded(el, img);
      return;
    }

    var done = function () {
      markLoaded(el, img);
    };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  }

  function bindSkeleton(el) {
    if (!el || el.classList.contains('is-loaded')) return;

    var ri = el.tagName === 'RESPONSIVE-IMAGE' ? el : el.querySelector('responsive-image');
    var img = (ri && ri.querySelector('img')) || el.querySelector('img');
    if (!img) return;

    if (ri && ri.classList.contains('m-image-loaded')) {
      markLoaded(el, img);
      return;
    }

    el.classList.add('m-image-skeleton');
    bindImg(el, img);

    if (ri && !ri.__charaaviSkeletonObserved) {
      ri.__charaaviSkeletonObserved = true;
      var obs = new MutationObserver(function () {
        if (ri.classList.contains('m-image-loaded')) {
          markLoaded(el, img);
          obs.disconnect();
        }
      });
      obs.observe(ri, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function init(root) {
    var scope = root || document;
    scope
      .querySelectorAll(
        '.m-media-gallery .m-product-media, .m-product-media--mobile .m-product-media, .deferred-media__poster'
      )
      .forEach(bindSkeleton);

    scope.querySelectorAll('.m-media-gallery responsive-image, .m-product-media--mobile responsive-image').forEach(function (ri) {
      var wrap = ri.closest('.m-product-media') || ri;
      bindSkeleton(wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function') {
    try {
      window.MinimogEvents.subscribe('m:image-loaded', function () {
        init();
      });
    } catch (e) {}
  }
})();
